import styled        from "styled-components"
import { Container } from "reactstrap"

const ContainerStyle = styled(Container)`
    height: 100%;
`

export default ContainerStyle
